/** EMIT */
export const EMIT_ENVIAR_MENSAGEM = 'enviarMensagem';
export const EMIT_ENVIAR_MENSAGEM_GRUPO = 'enviarMensagemGrupo';
export const EMIT_RECONECTAR_CANAL = 'reconectarCanal';
export const EMIT_JOIN_ROM_CONTATO = 'joinRomContato';
export const EMIT_LEAVE_ROM_CONTATO = 'leaveRomContato';
export const EMIT_DOWNLOAD_MIDIA = 'downloadMidia';
export const EMIT_DOWNLOAD_MIDIA_GRUPO = 'downloadMidiaGrupo';
export const EMIT_CONFIRMAR_LEITURA = 'confirmarLeitura';
export const EMIT_CONFIRMAR_LEITURA_GRUPO = 'confirmarLeituraGrupo';
export const EMIT_ENVIAR_ARQUIVO_GALERIA = 'enviarArquivoGaleriaV2';
export const EMIT_APAGAR_MENSAGEM = 'apagarMensagem';
export const EMIT_REENVIAR_MENSAGEM = 'reenviarMensagem';
export const EMIT_REENVIAR_MENSAGEM_GRUPO = 'reenviarMensagemGrupo';
export const EMIT_ROOM_QR_CODE = 'roomQRCode';
export const EMIT_GET_SESSAO_ATENDIMENTO = 'getSessaoAtendimento';
export const EMIT_EDITAR_MENSAGEM = 'editarMensagem';

/** ON */
export const ON_CONNECT = 'connect';
export const ON_RECONNECT = 'reconnect';
export const ON_DISCONNECT = 'disconnect';
export const ON_DESAUTENTICADO = 'desautenticado';
export const ON_CONNECT_ERROR = 'connect_error';
export const ON_CONECTOU_EM_OUTRO_LOCAL = 'conectouEmOutroLocal';
export const ON_CURRENT_VERSION = 'currentVersion';
export const ON_NOVO_STATUS_GRUPO = 'novoStatusGrupo';
export const ON_RECEBER_MENSAGEM = 'receberMensagem';
export const ON_RECEBER_MENSAGEM_GRUPO = 'receberMensagemGrupo';
export const ON_NOTIFICACAO = 'notificacao';
export const ON_CONEXAO_STATUS = 'conexaoStatus';
export const ON_CONTAR_NOVA_MENSAGEM = 'contarNovaMensagem';
export const ON_CONTAR_NOVA_MENSAGEM_GRUPO = 'countMsgsNaoLidasGrupo';
export const ON_CANAL_MENCIONADO_GRUPO = 'canalMencionadoGrupo';
export const ON_BAIXANDO_MIDIA_MENSAGEM = 'baixandoMidiaMensagem';
export const ON_ATUALIZAR_MIDIA_MENSAGEM = 'atualizarMidiaMensagem';
export const ON_BAIXANDO_MIDIA_MENSAGEM_GRUPO = 'baixandoMidiaMensagemGrupo';
export const ON_ATUALIZAR_MIDIA_MENSAGEM_GRUPO = 'atualizarMidiaMensagemGrupo';
export const ON_ADICIONADO_NOVO_GRUPO = 'adicionadoNovoGrupo';
export const ON_FOTO_GRUPO_ATUALIZADA = 'fotoGrupoAtualizada';
export const ON_ATENDIMENTO_STATUS = 'atendimentoStatus';
export const ON_CONTATO_STATUS = 'contatoStatus';
export const ON_FOTO_CONTATO_ATUALIZADA = 'fotoContatoAtualizada';
export const ON_CONTATO_BLOQUEADO = 'contatoBloqueado';
export const ON_CONTATO_DESBLOQUEADO = 'contatoDesbloqueado';
export const ON_MENSAGEM_STATUS = 'mensagemStatus';
export const ON_MENSAGEM_STATUS_GRUPO = 'mensagemStatusGrupo';
export const ON_MENSAGEM_APAGADA = 'mensagemApagada';
export const ON_MENSAGEM_APAGADA_GRUPO = 'mensagemApagadaGrupo';
export const ON_ATUALIZACAO_ACESSO_GRUPOS = 'atualizacaoAcessoGrupos';
export const ON_UPDATE_MENSAGENS_NAO_LIDAS_IN_CHAT_INTERNO =
  'updateMensagensNaoLidasInChatInterno';
export const ON_STORAGE_INFO = 'storageInfo';
export const ON_WHATSAPP_NEW_QR_CODE = 'whatsapp.newQrcode';
export const ON_WHATSAPP_NEW_CODE = 'whatsapp.newCode';
export const ON_WHATSAPP_CONECTADO = 'whatsapp.conectado';
export const ON_WHATSAPP_QR_CODE_TIMEOUT = 'whatsapp.qrcodeTimeout';
export const ON_WHATSAPP_NAO_CONECTADO = 'whatsapp.naoConectado';
export const ON_UPDATE_SESSAO_ATENDIMENTO = 'updateSessaoAtendimento';
export const ON_REACAO_MENSAGEM = 'reacaoMensagem';
export const ON_EDICAO_MENSAGEM = 'edicaoMensagem';
export const ON_SESSAO_INICIADA = 'sessaoIniciada';
export const ON_INATIVIDADE_ATENDENTE = 'notificarInatividadeAtendente';
export const ON_TRANSCRICAO_AUDIO = 'transcricaoAudio';
export const ON_SESSAO_ATUALIZADA = 'sessaoAtualizada';
export const ON_LIMPAR_FLAG_ATENDIMENTO = 'limparFlagAtendimento';
export const ON_CHANNEL_SEND_MODE_UPDATED = 'channelSendModeUpdated';
